/**
 * Customer identity: a customer needs a name, a phone number or an email, and none of
 * them alone is required (a caller often gives only a number). Same rule as the API,
 * customers.validators.has_customer_identity().
 */

export function hasCustomerName(customer) {
  if (!customer) return false;
  if (customer.type === 'company') {
    return !!customer.company_name?.trim();
  }
  return !!customer.first_name?.trim() || !!customer.last_name?.trim();
}

export function hasCustomerIdentity(customer) {
  if (!customer) return false;
  return hasCustomerName(customer) || !!customer.email?.trim() || !!customer.phone?.trim();
}

/**
 * What to call a customer in pickers: the name, or for a nameless one the phone number
 * or email, so it never shows up as a blank row.
 */
export function customerLabel(customer) {
  if (!customer) return '';
  return customer.name || customer.phone || customer.email || '';
}

/**
 * A nameless customer leaves no gap in a greeting: "Hei {{customer_name}}," reads "Hei,"
 * when there is no name. Same rule as the backend (reminders.services.without_empty_customer_token).
 */
export function withoutEmptyCustomerName(text, name) {
  if (!text || name) return text;
  return text.replace(/[ \t]*\{\{customer_name\}\}/g, '');
}
